import { userApi } from "@/core/data/api";

export default async (id) => {
  return await userApi.getUserDetail(id);
};
